import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@/App.css';
import Home from '@/pages/Home';
import Services from '@/pages/Services';
import Booking from '@/pages/Booking';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Accreditations from '@/pages/Accreditations';
import FAQ from '@/pages/FAQ';
import Reviews from '@/pages/Reviews';
import ServiceAreas from '@/pages/ServiceAreas';
import Pricing from '@/pages/Pricing';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsConditions from '@/pages/TermsConditions';
import CookiePolicy from '@/pages/CookiePolicy';
import ServiceDetail from '@/pages/ServiceDetail';
import Admin from '@/pages/Admin';
import DomesticEPCExeter from '@/pages/DomesticEPCExeter';
import FloorPlansExeter from '@/pages/FloorPlansExeter';
import CommercialEPC from '@/pages/CommercialEPC';
import CommercialEPCCity from '@/pages/CommercialEPCCity';
import CommercialEPCBristol from '@/pages/CommercialEPCBristol';
import CommercialEPCDevon from '@/pages/CommercialEPCDevon';
import CommercialEPCSomerset from '@/pages/CommercialEPCSomerset';
import CommercialEPCDorset from '@/pages/CommercialEPCDorset';
import CommercialEPCCornwall from '@/pages/CommercialEPCCornwall';
import CommercialEPCSouthampton from '@/pages/CommercialEPCSouthampton';
import LeasePlansWestCountry from '@/pages/LeasePlansWestCountry';
import SAPCalculations from '@/pages/SAPCalculations';
import UValueCalculations from '@/pages/UValueCalculations';
import PsiValueCalculations from '@/pages/PsiValueCalculations';
import PartOOverheating from '@/pages/PartOOverheating';
import SketchToCAD from '@/pages/SketchToCAD';
import PlanningDrawings from '@/pages/PlanningDrawings';
import LeasePlans from '@/pages/LeasePlans';
import Resources from '@/pages/Resources';
import EPCExplained from '@/pages/resources/EPCExplained';
import SAPvsEPC from '@/pages/resources/SAPvsEPC';
import UValueExamples from '@/pages/resources/UValueExamples';
import PsiValuesExplained from '@/pages/resources/PsiValuesExplained';
import PartOOverheatingGuide from '@/pages/resources/PartOOverheatingGuide';
import LeasePlanRequirements from '@/pages/resources/LeasePlanRequirements';
import IndustrialEPC from '@/pages/IndustrialEPC';
import WarehouseEPC from '@/pages/WarehouseEPC';
import WorkshopEPC from '@/pages/WorkshopEPC';
import FactoryEPC from '@/pages/FactoryEPC';
import IndustrialEPCDevon from '@/pages/IndustrialEPCDevon';
import IndustrialEPCCornwall from '@/pages/IndustrialEPCCornwall';
import IndustrialEPCSomerset from '@/pages/IndustrialEPCSomerset';
import IndustrialEPCDorset from '@/pages/IndustrialEPCDorset';
import SBEMExplained from '@/pages/SBEMExplained';
import MEESCommercialBuildings from '@/pages/MEESCommercialBuildings';
import CaseStudyExeterOfficeWorkshop from '@/pages/CaseStudyExeterOfficeWorkshop';
import CaseStudyExeterWorkshopRefurb from '@/pages/CaseStudyExeterWorkshopRefurb';
import CaseStudyExeterOfficeG2A from '@/pages/CaseStudyExeterOfficeG2A';
import CaseStudyLondonMEES from '@/pages/CaseStudyLondonMEES';
import CaseStudySticklepathSAP from '@/pages/CaseStudySticklepathSAP';
import CaseStudies from '@/pages/CaseStudies';
import QuickQuote from '@/pages/QuickQuote';
import Methodology from '@/pages/Methodology';
import AuthorZakHenning from '@/pages/AuthorZakHenning';
import HeatLoadCalculations from '@/pages/HeatLoadCalculations';
import EvidencePortal from '@/features/evidence/EvidencePortal';
import CookieBanner from '@/components/CookieBanner';
import LegacyRedirect from '@/components/LegacyRedirects';
import WhatsAppButton from '@/components/WhatsAppButton';
import { Toaster } from '@/components/ui/sonner';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Legacy URL Redirects - Must be FIRST to catch old WordPress URLs */}
          {/* Critical service redirects */}
          <Route path="/services/sap-calculations" element={<LegacyRedirect />} />
          <Route path="/services/u-value-calculations" element={<LegacyRedirect />} />
          <Route path="/services/u_values" element={<LegacyRedirect />} />
          <Route path="/services/floor-plans" element={<LegacyRedirect />} />
          <Route path="/services/lease-plans" element={<LegacyRedirect />} />
          
          {/* EPC service redirects */}
          <Route path="/services/epc" element={<LegacyRedirect />} />
          <Route path="/services/epc-services/bristol" element={<LegacyRedirect />} />
          <Route path="/services/epc-services/plymouth" element={<LegacyRedirect />} />
          <Route path="/services/epc-energy-performance-certificate" element={<LegacyRedirect />} />
          <Route path="/services/epc-energy-performance-certificate/exeter" element={<LegacyRedirect />} />
          
          {/* Other legacy service redirects */}
          <Route path="/non-domestic-epc" element={<LegacyRedirect />} />
          <Route path="/retrofit-coordinator" element={<LegacyRedirect />} />
          <Route path="/epc-exeter" element={<LegacyRedirect />} />
          <Route path="/important-changes-to-commercial-epc-results" element={<LegacyRedirect />} />
          
          {/* Legacy pages to home */}
          <Route path="/epc-plymouth-guide" element={<LegacyRedirect />} />
          <Route path="/category/epc" element={<LegacyRedirect />} />
          <Route path="/category/epc/*" element={<LegacyRedirect />} />
          
          {/* Main App Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/quick-quote" element={<QuickQuote />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/author/zak-henning" element={<AuthorZakHenning />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/accreditations" element={<Accreditations />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/independent-heat-load-calculations" element={<HeatLoadCalculations />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/domestic-epc-exeter" element={<DomesticEPCExeter />} />
          <Route path="/floor-plans-exeter" element={<FloorPlansExeter />} />
          <Route path="/commercial-epc" element={<CommercialEPC />} />
          <Route path="/commercial-epc-exeter" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-plymouth" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-torquay" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-newton-abbot" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-barnstaple" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-taunton" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-bridgwater" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-yeovil" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-truro" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-falmouth" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-newquay" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-bournemouth" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-poole" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-dorchester" element={<CommercialEPCCity />} />
          <Route path="/commercial-epc-bristol" element={<CommercialEPCBristol />} />
          <Route path="/commercial-epc-devon" element={<CommercialEPCDevon />} />
          <Route path="/commercial-epc-somerset" element={<CommercialEPCSomerset />} />
          <Route path="/commercial-epc-dorset" element={<CommercialEPCDorset />} />
          <Route path="/commercial-epc-cornwall" element={<CommercialEPCCornwall />} />
          <Route path="/commercial-epc-southampton" element={<CommercialEPCSouthampton />} />
          <Route path="/lease-plans-west-country" element={<LeasePlansWestCountry />} />
          <Route path="/sap-calculations" element={<SAPCalculations />} />
          <Route path="/u-value-calculations" element={<UValueCalculations />} />
          <Route path="/psi-value-calculations" element={<PsiValueCalculations />} />
          <Route path="/part-o-overheating" element={<PartOOverheating />} />
          <Route path="/sketch-to-cad" element={<SketchToCAD />} />
          <Route path="/planning-drawings" element={<PlanningDrawings />} />
          <Route path="/lease-plans" element={<LeasePlans />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/epc-explained" element={<EPCExplained />} />
          <Route path="/resources/sap-vs-epc" element={<SAPvsEPC />} />
          <Route path="/resources/u-value-examples" element={<UValueExamples />} />
          <Route path="/resources/psi-values-explained" element={<PsiValuesExplained />} />
          <Route path="/resources/part-o-overheating-guide" element={<PartOOverheatingGuide />} />
          <Route path="/resources/lease-plan-requirements" element={<LeasePlanRequirements />} />
          
          {/* Industrial EPC Pages */}
          <Route path="/industrial-epc" element={<IndustrialEPC />} />
          <Route path="/warehouse-epc" element={<WarehouseEPC />} />
          <Route path="/workshop-epc" element={<WorkshopEPC />} />
          <Route path="/factory-epc" element={<FactoryEPC />} />
          <Route path="/industrial-epc-devon" element={<IndustrialEPCDevon />} />
          <Route path="/industrial-epc-cornwall" element={<IndustrialEPCCornwall />} />
          <Route path="/industrial-epc-somerset" element={<IndustrialEPCSomerset />} />
          <Route path="/industrial-epc-dorset" element={<IndustrialEPCDorset />} />
          
          {/* Knowledge Hub Pages */}
          <Route path="/sbem-explained" element={<SBEMExplained />} />
          <Route path="/mees-commercial-buildings" element={<MEESCommercialBuildings />} />
          
          {/* Case Studies */}
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-study-exeter-office-workshop" element={<CaseStudyExeterOfficeWorkshop />} />
          <Route path="/case-study-exeter-workshop-refurbishment" element={<CaseStudyExeterWorkshopRefurb />} />
          <Route path="/case-study-exeter-office-g-to-a" element={<CaseStudyExeterOfficeG2A />} />
          <Route path="/case-study-london-mees-unit-split" element={<CaseStudyLondonMEES />} />
          <Route path="/case-study-sticklepath-sap-conversion" element={<CaseStudySticklepathSAP />} />

          {/* Internal Evidence Pack portal — protected, isolated module. Does NOT appear in sitemap/robots and has no public links. */}
          <Route path="/portal/evidence/*" element={<EvidencePortal />} />
        </Routes>
        <CookieBanner />
        <WhatsAppButton />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </HelmetProvider>
  );
}

export default App;